import { FC, SVGProps } from 'react'

export const IconMailCheck: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    stroke="#0062CA"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M42.1666 24.9166V11.5C42.1666 10.4833 41.7627 9.50827 41.0438 8.78938C40.3249 8.07049 39.3499 7.66663 38.3333 7.66663H7.66659C6.64992 7.66663 5.6749 8.07049 4.95601 8.78938C4.23712 9.50827 3.83325 10.4833 3.83325 11.5V34.5C3.83325 36.6083 5.55825 38.3333 7.66659 38.3333H22.9999"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.1666 13.4166L24.9741 24.3416C24.3824 24.7124 23.6982 24.909 22.9999 24.909C22.3016 24.909 21.6175 24.7124 21.0258 24.3416L3.83325 13.4166"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.6667 36.4167L34.5001 40.25L42.1667 32.5834"
      fill="none"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
